import axios from "axios";

function joinUrl(base, segment) {
  const b = (base || "").replace(/\/+$/, "");      // trim trailing slash
  const s = (segment || "").replace(/^\/+/, "");   // trim leading slash
  return `${b}/${s}`;
}

export function configureAxios(apiBase) {
  const base = joinUrl(apiBase || "/", "api");
  axios.defaults.baseURL = base;
  // axios.defaults.withCredentials = true; // enable if using Sanctum cookies
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("freshToken");
}

export default axios;
